/* Presentation helpers for contractor fleet rows. */

export function fmtMins(mins) {
  if (mins == null) return "";
  if (mins <= 0) return "due now";
  if (mins < 60) return `${mins} min`;
  return `${Math.floor(mins / 60)}h ${mins % 60}m`;
}

export function agoLabel(iso) {
  if (!iso) return "no GPS";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  return `${Math.floor(s / 3600)}h ago`;
}

export function describeTruck(t) {
  const plant = t.plant?.name || t.org?.name || "plant";
  const site = t.job?.site_name || t.job?.site_address || "job site";
  const toSite = { eta: t.eta?.to_site, etaMins: t.eta?.to_site_mins, running: !!t.eta?.to_site_running };
  const back = { eta: t.eta?.back_to_plant, etaMins: t.eta?.back_mins, running: !!t.eta?.back_running };
  switch (t.status) {
    case "loading":
    case "slumping":
      return { headline: `Loading at ${plant}`, next: t.job ? `Next: ${site}` : "Awaiting dispatch", ...toSite, running: false, etaLabel: "ETA site (planned)" };
    case "en_route":
      return { headline: `En route → ${site}`, next: `From ${plant}`, ...toSite, etaLabel: "ETA site" };
    case "on_site":
    case "discharging":
      return { headline: `On site · ${site}`, next: `Returns to ${plant}`, ...back, running: false, etaLabel: "ETA plant" };
    case "returning":
      return { headline: `Returning → ${plant}`, next: `From ${site}`, ...back, etaLabel: "ETA plant" };
    case "maintenance":
    case "out_of_service":
      return { headline: "Out of service", next: plant, eta: null, etaMins: null, running: false };
    default:
      return { headline: `Available · ${plant}`, next: "Waiting for next load", eta: null, etaMins: null, running: false };
  }
}
